export default "__VITE_ASSET__a0c8918d__"